"use client";

import React, {JSX} from "react";

import {useTranslation} from "@/shared/i18n";

interface Props {
    loading?: boolean;
    price?: string | null;
    note?: string;
}

export function PriceSkeleton({loading, price, note}: Props): JSX.Element {
    const {t} = useTranslation("booking");
    const defaultNote = note ?? t("totalExclTaxes");
    if (loading) {
        return (
            <>
                <span className="check-availability-mobile__skeleton" />
                <span className="check-availability-mobile__skeleton check-availability-mobile__skeleton--small" />
            </>
        );
    }

    if (!price) {
        return <></>;
    }

    return (
        <>
            <span className="check-availability-mobile__total">{price}</span>
            <span className="check-availability-mobile__total-note">{defaultNote}</span>
        </>
    );
}
